import type { IconData } from '@stacksjs/iconify-core'

export const sy1x1: IconData = {
  "body": "<path d=\"M0 0h512v512H0Z\"/><path fill=\"#fff\" d=\"M0 0h512v341.3H0Z\"/><path fill=\"#007a3d\" d=\"M0 0h512v170.7H0Z\"/><path fill=\"#ce1126\" d=\"M26.3 317.9L67.2 192L108 317.9L1 240h132.4m270.5 77.8L445 192l40.8 125.9l-107-77.8H511m-295.9 77.8L256 192l40.9 125.9l-107-77.8h132.3\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sy1x1
